export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00277.7154ddc6.png";